const GetMonthlyPayment = (loanAmount, annualRate, loanTermYears) => {
  const monthlyRate = Number(annualRate) / 100 / 12; // Monthly interest rate

  const nPayments = Number(loanTermYears) * 12; // Total number of payments

  const monthlyRepayment =
    (Number(loanAmount) * monthlyRate) /
    (1 - Math.pow(1 + monthlyRate, -nPayments)); // Monthly repayment (M)

  return monthlyRepayment;
};

export default GetMonthlyPayment;
